import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle scroll effects
  useEffect(() => {
    const handleScroll = () => {
      // Navbar background change on scroll
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
      
      // Highlight active section based on scroll position
      const sections = document.querySelectorAll('.section[id]');
      
      if (sections.length) {
        let current = '';
        
        sections.forEach((section) => {
          const sectionTop = section.offsetTop;
          const sectionHeight = section.clientHeight;
          
          if (window.scrollY >= sectionTop - 200 && 
              window.scrollY < sectionTop + sectionHeight - 200) {
            current = section.getAttribute('id');
          }
        });
        
        setActiveSection(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Close mobile menu when clicking outside
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.navbar-container')) {
        setIsMenuOpen(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close mobile menu when resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuOpen]);

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          Opi<span>Tech</span>
        </Link>
        
        <button 
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className={`navbar-toggle-icon ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <NavLink 
              to="/" 
              className={({ isActive }) => 
                isActive ? "navbar-link active" : "navbar-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/services" 
              className={({ isActive }) => 
                isActive ? "navbar-link active" : "navbar-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </NavLink>
          </li>
          {/* <li>
            <NavLink 
              to="/portfolio" 
              className={({ isActive }) => 
                isActive ? "navbar-link active" : "navbar-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Work
            </NavLink>
          </li> */}
          <li>
            <NavLink 
              to="/about" 
              className={({ isActive }) => 
                isActive ? "navbar-link active" : "navbar-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/contact" 
              className={({ isActive }) => 
                isActive ? "navbar-link active" : "navbar-link"
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </NavLink>
          </li>
          <li className="navbar-cta">
            <Link 
              to="/contact" 
              className="btn btn-sm"
              onClick={() => setIsMenuOpen(false)}
            >
              <span className="btn-text">Get a Quote</span>
              <span className="btn-icon">
                <i className="fas fa-arrow-right"></i>
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;